import * as React from 'react';
import styled from 'styled-components';
import ChromePicker from 'react-color/lib/Chrome';
import chroma from 'chroma-js';
import stateSettings from '@state/settings';
import stateUi from '@state/ui';
import { findNearestColor } from './colorList';
import { connect } from 'lape';
import { useRef } from 'react';
import useClickAway from 'react-use/esm/useClickAway';
const Wrapper = styled.div `
  position: relative;
  margin-bottom: 16px;
`;
const ColorDelete = styled.div `
  cursor: pointer;
  position: absolute;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ color }) => color};
  color: ${({ color }) => (chroma(color).luminance() > 0.5 ? 'black' : 'white')};
  top: -4px;
  right: -4px;
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.3s;
`;
const ColorBox = styled.div `
  position: relative;
  cursor: pointer;
  width: 65px;
  height: 65px;
  border-radius: 7%;
  margin: 0 16px 0 0;
  background-color: ${(props) => props.color};
  &:hover ${ColorDelete} {
    opacity: 1;
  }
`;
const Input = styled.input `
  outline: 0;
  border: none;
  padding-bottom: 5px;
  transition: all 200ms ease;
  width: 135px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  &:hover {
    box-shadow: inset 0 -2px 0 0 rgba(0, 0, 0, 0.35);
  }

  &:focus {
    box-shadow: inset 0 -2px 0 0 rgba(0, 0, 0, 0.85);
  }
`;
const ColorWithInputWrapper = styled.div `
  display: flex;
`;
const InputWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 2px 0;
  margin-right: 15px;
`;
const PickerWrapper = styled.div `
  z-index: 1;
  position: absolute;
  top: 110%;
  left: 0;
`;
const onEditingColorChange = (id) => () => {
    stateUi.editingColorId = id;
};
const onClickOutside = () => {
    stateUi.editingColorId = '';
};
const onColorChange = (color) => (colorChroma) => {
    color.name = findNearestColor(colorChroma.hex).name;
    color.hex = colorChroma.hex;
};
const onColorNameChange = (color) => (event) => {
    color.name = event.target.value;
};
const onHexValueChange = (color) => (event) => {
    color.hex = event.target.value;
};
const onDelete = (color) => () => {
    stateSettings.colors.splice(stateSettings.colors.indexOf(color), 1);
};
const ColorBoxWithPicker = ({ color, editing }) => {
    const ref = useRef(null);
    useClickAway(ref, onClickOutside);
    return (React.createElement(Wrapper, null,
        React.createElement(ColorWithInputWrapper, null,
            React.createElement(ColorBox, { color: color.hex, onClick: onEditingColorChange(color.id) },
                React.createElement(ColorDelete, { color: color.hex, onClick: onDelete(color) },
                    React.createElement("i", { className: "material-icons" }, "clear"))),
            React.createElement(InputWrapper, null,
                React.createElement(Input, { type: "text", placeholder: "Color name", id: color.id, name: color.id, value: color.name, onChange: onColorNameChange(color) }),
                React.createElement(Input, { type: "text", placeholder: "Hex value", id: color.id, name: color.id, value: color.hex, onChange: onHexValueChange(color) }))),
        editing && (React.createElement(PickerWrapper, { ref: ref },
            React.createElement(ChromePicker, { color: color, onChange: onColorChange(color) })))));
};
export default connect(ColorBoxWithPicker);
